import React, { useCallback, memo, useEffect, useState } from "react"
import PricingCards from "./pricingCards"
import isEmail from 'validator/lib/isEmail';
import isMobilePhone from 'validator/lib/isMobilePhone'
import { useWatch } from "react-hook-form";
export const Pricing = memo(({ setValue, action, }) => {

    const updateForm = useCallback((e, name) => {
        e.preventDefault()
        setValue('pricing', name)
        action(name)

    }, [setValue, action])

    return (
        <div className="max-1200 ma flex pt20 m-flex-col ">
            <PricingCards onClick={updateForm} />
        </div>
    )
})



export const About = memo(({ register, getFieldState, isErrored }) => {

    const name = getFieldState('name')
    const lastName = getFieldState('lastName')
    const phoneNumber = getFieldState('phoneNumber')
    const email = getFieldState('email')
    const location = getFieldState('location')

    return (
        <div className="p50 r30 bg-white max-1200 ma m-p20 ">

            <div className="flex w-100 m-flex-col ">
                <div className="flex flex-col flex-grow-1">
                    <h4 className="m0 mb20">First name*</h4>
                    <input placeholder="James" className={"mr20 m-mr0   " + isErrored(name)}{...register("name", { required: true })} />
                </div>
                <div className="flex flex-col flex-grow-1 m-pt20">
                    <h4 className="m0 mb20">Last name*</h4>
                    <input placeholder=" Smith" className={"mr20 m-mr0   " + isErrored(lastName)}{...register("lastName", { required: true })} />
                </div>
            </div>
            <input name="pricing" hidden />
            <div className="flex w-100 pt40 m-pt20   m-flex-col">
                <div className="flex flex-col flex-grow-1">
                    <h4 className="m0 mb20">Phone Number*</h4>
                    <input placeholder="04 1234 5678" className={"mr20 m-mr0   " + isErrored(phoneNumber)}{...register("phoneNumber", { required: true, validate: (value) => isMobilePhone(value) })} />
                </div>
                <div className="flex flex-col flex-grow-1 m-pt20">
                    <h4 className="m0 mb20">Email address*</h4>
                    <input placeholder="james@gmail.com" className={"mr20 m-mr0   " + isErrored(email)}{...register("email", { required: true, validate: (value) => isEmail(value) })} />
                </div>
            </div>
            <div className="pt40 m-pt20">
                <h4 className="m0 mb20">Where are you from?*</h4>
                <input placeholder="QLD - South" className={"mr20 w-100 m-mr0   " + isErrored(location)}{...register("location", { required: true })} />
            </div>
        </div>
    )
})


export const AboutCar = memo(({ register, setValue, getFieldState, isErrored }) => {

    const make = getFieldState('make')
    const model = getFieldState('model')
    const year = getFieldState('year')


    return (
        <div className="p50 r30 bg-white max-1200 ma m-p20 ">

            <div className="flex w-100 m-flex-col ">
                <div className="flex flex-col flex-grow-1">
                    <h4 className="m0 mb20">Make*</h4>
                    <input placeholder="Mazda" className={"mr20  m-mr0  " + isErrored(make)} {...register("make", { required: true })} />
                </div>
                <div className="flex flex-col flex-grow-1 m-pt20 m-mr0  ">
                    <h4 className="m0 mb20">Model*</h4>
                    <input placeholder="3" className={"mr20  m-mr0  " + isErrored(model)} {...register("model", { required: true })} />
                </div>
            </div>
            <div className="flex w-100 pt40 m-flex-col m-pt20 ">
                <div className="flex flex-col flex-grow-1">
                    <h4 className="m0 mb20">Year*</h4>
                    <input placeholder="2010" className={"mr20 m-mr0   " + isErrored(year)} {...register("year", { required: true, validate: (value) => !isNaN(value) })} />
                </div>
                {/*
                <div className="flex flex-col flex-grow-1 m-pt20">
                    <h4 className="m0 mb20">Odometer*</h4>
                    <input placeholder="30,000KM" className={"mr20  m-mr0  " + isErrored(odometer)}  {...register("odometer", { required: true })} />
                </div>
                */}
            </div>
            {/*
            <div className="flex w-100 pt40 m-flex-col m-pt20 ">
               
                <div className="flex flex-col flex-grow-1 w-50 m-w100 ">
                    <h4 className="m0 mb20">Badge*</h4>
                    <input placeholder="Mazda 3 Maxx Sport" className={"mr20 m-mr0  " + isErrored(badge)}  {...register("badge", { required: true })} />
                </div>
               
                <div className="flex flex-grow-1 w-50 m-pt20 m-w100 m-grid m-gap-15">
                    <div className="flex-grow-1 mr20 flex flex-col m-mr0 m-justify-between   " >
                        <h4 className="m0 mb20">Finance owing</h4>
                        <Toggle name='Finance owing' setValue={setValue} />
                    </div>
                    <div className="flex-grow-1 mr20  flex flex-col m-mr0  m-justify-between" >
                        <h4 className="m0 mb20">Service history</h4>
                        <Toggle name='Service history' setValue={setValue} />
                    </div>
                    <div className="flex-grow-1 flex flex-col m-justify-between" >
                        <h4 className="m0 mb20">Log Books*</h4>
                        <Toggle name='Log Books' setValue={setValue} />
                    </div>
                </div>
            </div>
            <div className="w-100 flex flex-col pt40 m-pt20 ">
                <h4 className="m0 mb20">Condition report</h4>
                <textarea placeholder="Please list any Interior / exterior damage (please be specific so we can accurately price your car)" {...register('Condition report')} />
            </div>*/}
        </div>
    )
})

export const Images = memo(({ register, control, setValue }) => {
    return (
        <div className="p50 r30 bg-white max-1200 ma m-p20 ">
            <div className="">
                <h4 className="m0 mb20">Exterior front</h4>
                <FileWrapper control={control} setValue={setValue} register={register} name="Exterior front" />
            </div>
            <div className="pt40 m-pt20 ">
                <h4 className="m0 mb20">Exterior back</h4>
                <FileWrapper control={control} setValue={setValue} register={register} name="Exterior back" />
            </div>
            <div className="pt40  m-pt20 ">
                <h4 className="m0 mb20">Exterior side one</h4>
                <FileWrapper control={control} setValue={setValue} register={register} name="Exterior side one" />
            </div>
            <div className="pt40  m-pt20 ">
                <h4 className="m0 mb20">Exterior side two</h4>
                <FileWrapper control={control} setValue={setValue} register={register} name="Exterior side two" />
            </div>
            <div className="pt40  m-pt20 ">
                <h4 className="m0 mb20">Interior</h4>
                <FileWrapper control={control} setValue={setValue} register={register} name="Interior" />
            </div>
        </div>
    )
})

const FileWrapper = memo(({ name, register, control, setValue }) => {

    const value = useWatch({
        control,
        name,
        defaultValue: []
    });

    return (
        <div className="input file-input-wrapper">
            {value.length < 1 ? <input type='file' className="mb20 w-100 file-input "{...register(name, { maxLength: 1 })} /> : null}
            <div className="file-overlay">
                <div className="flex">
                    {value.length < 1 ?
                        (
                            <>
                                <div className="grey-button mr20">
                                    Choose File
                                </div>
                                <div className="op-50 flex flex-col justify-center ">
                                    No File selected

                                </div>
                            </>
                        )
                        : (
                            <button className="file-button" onClick={() => setValue(name, [])}>
                                {value[0].name.slice(0, 6)}...{value[0].name.slice(-7)} <div className="cross" />
                            </button>
                        )}
                </div>
            </div>
        </div>
    )
})


const Toggle = ({ setValue, name }) => {

    const [value, changeValue] = useState(false)

    useEffect(() => {
        setValue(name, value)
    }, [value, setValue, name])

    const changeValueTo = useCallback((e) => {
        e.preventDefault()
        changeValue((state) => !state)
    }, [])

    return (
        <>
            <input hidden={true} name={name} />
            <button onClick={changeValueTo} className="input toggle">
                <div style={{ transform: `translate(${value ? '100%' : '0%'})` }} className="active-indicator" />
                <div className="toggle-option unset-button ">
                    No
                </div>
                <div className="toggle-option unset-button">
                    Yes
                </div>
            </button>
        </>
    )
}